import { render, staticRenderFns } from "./Popup2.vue?vue&type=template&id=516d1ee2"
import script from "./Popup2.vue?vue&type=script&lang=js"
export * from "./Popup2.vue?vue&type=script&lang=js"
import style0 from "./Popup2.vue?vue&type=style&index=0&id=516d1ee2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports